import React, { useEffect, useState } from 'react';
import Table from '../../../../components/CustomTable';
import { options, platformsConfig } from './constant';
import { connect, useDispatch, useSelector } from 'react-redux';
import _, { isEmpty, get, cloneDeep } from 'lodash';
import routes from '../../../../routes';
import moment from 'moment';
import { Modal } from 'semantic-ui-react'

import {
  getCampaignListAllReportAction,
  getIoAdvertisersReportAction,
  deleteCampaignAction,
  getCampaignEditIdReportAction,
  addCampaignAction,
  getCountryAction,
  getPrivateMarketPlaceAction,
  postCampaignListAllAction,
  getCampaignCustomAction,
  updateCampaignStatusAction,
  getCampaignListByIdAction,
  getPaymentRelatedAccessAction,
  getCampaignFilterAction,
  postCampaignFilterAction,
  postCampaignStatusAction,
  clearAllReduxDataDashoardScreen2
} from '../../../../actions';
import { withRouter } from 'react-router-dom';
import { setStepperEditAction } from '../../../../actions/customPlanDetails';
import { accessCheck } from '../../../../helpers/planAccessConstant/constant';
import { postCampaignAction, reduxCampaignDataAction, reduxDataForAccordianOpenCampaignAction } from '../../../../actions/campaign';
import { getCurrentDateInTimeZone, getDateFromUtcToSpecificZone, getValidCampaignsId, isApiCallSuccess } from '../../../../selectors';
import { message } from 'antd';
import { campaignListMessages } from '../constant';
import { checkTablePermission } from '../../../../utils/route-auth';
import { PERMISSION } from '../../../../constants/permission';
import { downloadSdfApiCall } from '../../../../api';
import FileSaver from 'file-saver';


function Index(props) {

  const tenantId = useSelector(state => get(state, 'app.preSignInState.tenantId', ''));
  const userId = useSelector(state => get(state, 'app.preSignInData.userId', ''));
  const authToken = useSelector(state => get(state, 'app.signInData.authToken', ''));
  const camapignAccess = useSelector((state) => get(state, "app.subscriptionCurrentData.campaign", []));

  const dispatch = useDispatch();

  const [optionsList, setOptionsList] = useState(options);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
  const [errorArray, setErrorArray] = useState([]);


  const handleCampaignPermission = camapignAccess && camapignAccess.length > 0 && camapignAccess[0].access
  // console.log(handleCampaignPermission, "123")

  useEffect(() => {
    if (props.targetTimeZone) {
      let optionCloned = _.cloneDeep(options);

      optionCloned.columns.forEach((dataCol, index) => {
        if (dataCol.name == "recos") {
          optionCloned.columns[index].component = (row) => <div class="d-flex align-items-center">{row.recos} <a>
            {
              row.recos == 1 && <i onClick={() => { routeToOptimiser(props.history, row) }} style={{ cursor: 'pointer' }} class="ti ti-external-link ti-xs pl-1 text-primary"></i>
            }
          </a> </div>
        }
        if (dataCol.name == "campaignName") {
          optionCloned.columns[index].component = (row) => <div>
            <span>{row.campaignName}</span>
            {
              row.synced == 2 &&
              <span title='Missing Details'><i style={{ color: 'grey', fontSize: 16 }} className='mdi mdi-alert ml-2'></i></span>
            }
          </div>
        }
        if (dataCol.name == "budget") {
          dataCol.label = props.budgetLabel ? props.budgetLabel : dataCol.label;
        }
        if (dataCol.name == "startDate") {
          optionCloned.columns[index].component = (row) => row.startDate ? moment(getDateFromUtcToSpecificZone({ date: row.startDate, targetTimeZone: props.targetTimeZone })).format('D-MMM-YY') : '-'
        }
        if (dataCol.name == "endDate") {
          optionCloned.columns[index].component = (row) => row.endDate ? moment(getDateFromUtcToSpecificZone({ date: row.endDate, targetTimeZone: props.targetTimeZone })).format('D-MMM-YY') : '-'
        }
      })


      if (handleCampaignPermission == accessCheck.READ_ACCESS) {
        optionCloned.actionsThead = false
      }

      optionCloned = checkTablePermission({ add: PERMISSION.CAMPAIGN.CAMPAIGN.ADD, edit: PERMISSION.CAMPAIGN.CAMPAIGN.EDIT, view: PERMISSION.CAMPAIGN.CAMPAIGN.VIEW }, optionCloned);
      setOptionsList(optionCloned);
    }
  }, [props.targetTimeZone])

  const routeToOptimiser = (history, row) => {
    history.push(`/${routes.mainRoute}/${routes.containers.optimizer}/${routes.optimizer.recommendations}/${row.advertiserId ? row.advertiserId : -1}`)
  }


  const collectErrors = (obj) => {
    let errors = [];

    // Recursive function to check for errors in nested objects
    const checkForErrors = (currentObj) => {
      if (currentObj.isErrorPresent) {
        if (Object.keys(currentObj.errors.length > 0)) {
          if (currentObj.errors.hasOwnProperty("error")) {
            errors.push({ ...currentObj.errors.error, headingError: `${currentObj.errors.error.name}` })
          }
          if (currentObj.errors.hasOwnProperty("strategy") && currentObj.errors.strategy.length > 0) {
            currentObj.errors.strategy.forEach((data) => {
              if (data.hasOwnProperty("error")) {
                errors.push({ ...data.error, headingError: `${data.error.name}` })
              }
              if (data.hasOwnProperty("creative") && data.creative.length > 0) {
                data.creative.forEach((creativeData) => {
                  if (creativeData.hasOwnProperty("error")) {
                    errors.push({ ...creativeData.error, creativeName: creativeData.error.name, headingError: `${data.error && data.error.name ? data.error.name : ''}` })
                  }
                })
              }
            })
          }
        }
      }

      return errors;
    }

    // Start the recursion
    return checkForErrors(obj);
  }
  // console.log(props,"props")
  const handleAction = (row, action) => {
    const { match, history } = props;
    // console.log("111",row,action)
    if (action.key === "status") {
      handleStatus(row)
    }
    else if (action.type === 'chart') {
      routeToDashBoardSecondScreen(row);
    } else if (action.type === 'edit') {
      // console.log(row)
      dispatch(setStepperEditAction({ stepperValue: 1, screen: '' }));
      dispatch(reduxCampaignDataAction({ data: null }));
      dispatch(reduxDataForAccordianOpenCampaignAction({ data: null }));
      const location = {
        pathname: `/${routes.mainRoute}/${routes.containers.campaignList}/${routes.campaign.edit}/${row.mandateId}`,
        state: {
          data: {
            childCampaignId: row.campaignId,
            isChildEdit: true,
            isRecomended: false
          }
        }
      };
      history.push(location);
    } else if (action.type === 'view') {
      // console.log(row)
      dispatch(setStepperEditAction({ stepperValue: 1, screen: '' }));
      dispatch(reduxCampaignDataAction({ data: null }));
      dispatch(reduxDataForAccordianOpenCampaignAction({ data: null }));
      const location = {
        pathname: `/${routes.mainRoute}/${routes.containers.campaignList}/${routes.campaign.view}/${row.mandateId}`,
        state: {
          data: {
            childCampaignId: row.campaignId,
            isChildEdit: true,
            isRecomended: false
          }
        }
      };
      history.push(location);
    }
    else if (action.type === "error") {
      const errorData = collectErrors(row);
      console.log(errorData);
      if (errorData.length > 0) {
        setErrorArray(errorData)
        setIsErrorModalOpen(!isErrorModalOpen);

      }
    } else if (action.type === "download" && row.isYoutubeCampaign) {
      handleSdfFileDownload(row)
    }
    else if (action.type === "download" && row.isYoutubeCampaign) {
      handleSdfFileDownload(row)
    }
  };

  const handleSdfFileDownload = async (row) => {

    const platformKey = Object.keys(platformsConfig).find(key => key == row.platform)
    const payload = {
      tenantId, authToken, userId, campaignId: row.campaignId, platform: platformsConfig[platformKey]
    }

    await downloadSdfApiCall(payload).then(response => {
      const { data, headers } = response;
      const contentDisposition = headers['content-disposition'];

      if (contentDisposition && contentDisposition.includes('attachment')) {

        const originalFileName = Array.isArray(contentDisposition.split('filename=')) && contentDisposition.split('filename=')[1] && contentDisposition.split('filename=')[1].replace(/"/g, '') || 'sdf-reports.zip';
        const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
        const fileNameWithTimestamp = originalFileName.replace(/(\.[a-zA-Z0-9]+)$/, `_${timestamp}$1`);
        let blob = new Blob([data], { type: 'application/zip' });

        FileSaver.saveAs(blob, fileNameWithTimestamp);
        message.success("SDF file download started!");

      } else {
        message.error("No available files to download!");
      }
    }).catch(err => {
      message.error("Something went wrong!");
      console.error(err);
    });
  };


  const routeToDashBoardSecondScreen = async (item) => {
    const { history } = props;

    const currentDate = getCurrentDateInTimeZone(props.targetTimeZone);

    const defaultDate = currentDate; // Example default date in YYYY-MM-DDTHH:mm:ss format
    const defaultMoment = moment(defaultDate, 'YYYY-MM-DD hh:mm:ss');
    const defaultMomentEnd = moment(defaultDate, 'YYYY-MM-DD hh:mm:ss');
    const sDate = defaultMoment.subtract(7, 'days');
    const eDate = defaultMomentEnd.subtract(1, 'days');
    const formattedSDate = sDate.format('YYYY-MM-DD');
    const formattedEDate = eDate.format('YYYY-MM-DD');

    const dateRange = {
      sdate: formattedSDate,
      edate: formattedEDate
    };

    localStorage.setItem("dateRange", JSON.stringify(dateRange));

    await dispatch(clearAllReduxDataDashoardScreen2()).then(async (data) => {
      const location = {
        pathname: `/${routes.mainRoute}/${routes.containers.dashboard}`,
        state: {
          data: {
            campaigns: [{
              "value": item.platformCampId ? item.platformCampId : -1,
              "label": item.platformCampId ? item.platformCampId : '',
              "name": "campaign"
            }], screen: 'second'
          }
        }
      };
      history.push(location);
    })
  };

  const handleStatus = async (row) => {
    const { history } = props;

    let payload = {
      bekiCampaignId: props.row.campaignId,
      platformCampaignId: row.campaignId,
      status: row.status == 1 ? 0 : 1,
    };

    if (row.status == 0) {

      if (row.synced == 2) {
        message.error(campaignListMessages.noValidCampaigns);
        return;
      }

      const params = {
        list: "preview"
      }

      await dispatch(postCampaignAction({
        tenantId, authToken, userId, params, payload: {
          "mandateId": row.mandateId,
          "campaignIds": [row.campaignId]
        }
      })).then((data) => {
        const { responseCode: { status = "", msg = "" }, response = [] } = data;
        if (isApiCallSuccess(status)) {
          if (response.length > 0) {
            const validCampaignsArray = getValidCampaignsId(response);
            if (validCampaignsArray.length > 0) {
              const objectForCampaignPublish = {
                isSaveEnabled: false,
                status: true,
                redirectScreen: 'campaign-list',
                publishDataAll: response,
                payload: {
                  mandateId: parseInt(row.mandateId),
                  campaignIds: validCampaignsArray,
                },
              };

              dispatch(reduxCampaignDataAction({ data: null }));
              dispatch(reduxDataForAccordianOpenCampaignAction({ data: null }));
              const location = {
                pathname: `/${routes.mainRoute}/${routes.containers.campaignList}/${routes.campaign.edit}/${row.mandateId}`,
                state: {
                  data: {
                    objectForCampaignPublish: objectForCampaignPublish,
                  },
                },
              };
              history.push(location);
            }
            else {
              message.error(campaignListMessages.noValidCampaigns)
            }
          }
        }
      })
    } else {
      await dispatch(
        postCampaignStatusAction({ tenantId, authToken, userId, payload })
      )
        .then((data) => {
          // console.log("data", data)
          const {
            responseCode: { status = "", msg },
            response,
          } = data;

          if (status === "Success") {
            props.toast(status, msg, "statusUpdate");
          } else {
            props.toast(status, msg, "statusUpdate");
            // console.log("List data not found");
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  return (
    <div className="table-responsive">
      <Modal
        open={isErrorModalOpen}
        size={"small"}
      >
        <div className="modal-content" style={{ boxShadow: "unset" }}>
          <div className="modal-header">
            <h5
              className="modal-title"
              style={{ margin: "0 auto", color: "#040B1B" }}
            >
              Campaign Errors
            </h5>
            <button
              type="button"
              onClick={() => {
                setIsErrorModalOpen(!isErrorModalOpen);
              }}
              className="close ml-0"
              data-dismiss="modal"
              aria-label="Close"
            >
              <div className="modal-title modal-colse modal-cross">
                <span aria-hidden="true">x</span>
              </div>
            </button>
          </div>
          <Modal.Content>
            <div
              className="modal-body  showScrollBar"
              style={{ overflowY: "scroll", maxHeight: 450 }}
            >
              <>
                {
                  errorArray.map((data, index) => (
                    <div key={index} className='mt-4 suspend'>
                      <h6 style={{ fontSize: 14, fontWeight: 500 }} className='text-danger'><i class="mdi mdi-alert" style={{ color: 'red', fontSize: 20 }}></i>&nbsp; {data.headingError}</h6>
                      <div className='d-flex'>
                        {
                          data.creativeName &&
                          <p style={{ fontWeight: 500 }} className='text-gray'>
                            {data.creativeName} -
                          </p>
                        }
                        <p className='text-gray ml-1'>{data.errorMsg}</p>
                      </div>
                    </div>
                  ))
                }
              </>
            </div>
          </Modal.Content>
          <Modal.Actions>

          </Modal.Actions>
        </div>
      </Modal>
      <Table
        options={optionsList}
        data={props.row.campaigns || []}
        handelAction={handleAction}
      />
    </div>
  );
}

export default withRouter(Index);
